import { useQuery } from '@tanstack/react-query';
import { apiFetch } from 'utils/apiUtils.ts';
import useAuth from 'hooks/useAuth.ts';
import { TeamDetailsResponseSchema } from 'schemas/TeamDetails.schema.ts';

interface IFetchTeamDetailsVariables {
  teamId: string,
}

export default function useFetchTeamDetails({ teamId }: IFetchTeamDetailsVariables) {
  const { tokens } = useAuth();
  return useQuery({
    queryKey: ['team', { teamId }],
    queryFn: async () => apiFetch<TeamDetailsResponseSchema>({
      path: `team/${teamId}/details`,
      method: 'GET',
      accessToken: String(tokens.accessToken),
    }),
  });
}
